import React, { useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"

import HomeBoxByRoleLXO from "components/HomeBoxByRoleLXO/HomeBoxByRoleLXO"
import { selectAuth, setCenterId } from "shared/redux/slices/authSlice"

// Roles without a dedicated Home design reuse the LXO layout. The LXO sections
// read auth.centerId directly, so pin a center when the role has none.
const FALLBACK_CENTER_ID = 1

const HomeBoxByRoleDefault = () => {
  const auth = useSelector(selectAuth)
  const dispatch = useDispatch()

  useEffect(() => {
    if (!auth?.centerId) {
      dispatch(setCenterId({ centerId: FALLBACK_CENTER_ID }))
    }
  }, [auth?.centerId, dispatch])

  return <HomeBoxByRoleLXO showPerformanceCards={false} />
}

export default HomeBoxByRoleDefault
